import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const wesaudio: IBrand = {
  id: "wesaudio",
  name: BRAND.WESAUDIO,
  logo: "/logo/WesAudioLogoTransparent.png",
  website: "https://wesaudio.com/",
  description: `
WesAudio has been a manufacturer of professional audio equipment since 2010.  
Company legacy lies in modern approach to classic analog equipment, however since 2013 a new branch of development has been started bringing into market innovative and modern “Next Generation” line of units for professional audio processing.  

With over 10 years of experience building outboard gear, WesAudio is one of the manufacturers that makes innovative and next generation units for audio processing. 
Their next generation products have analog circuitry and the benefits of digital recall. A great fit for hybrid workflows. 
Used by professionals such as Stuart White (Beyonce), Tobby Francis (FOH for Red Hot Chilli Peppers tour 2022, Ariana Grande tour 2019 and Katy Perry tour 2018), Andy Meyer (FOH Justin Timberlake tour 2018) to name a few. 
They are proven to be great for live sound as well. 

WesAudio’s main goal remains the same – create beautiful sounding analog equipment with great modern features for an affordable price.  
We strive to assure that our products are of high quality and precision, we provide full warranty and service of all the equipment available for sale.  
`,
  videos: ["https://www.youtube.com/embed/TKdz6pRPXwk", "https://www.youtube.com/embed/2F_QsOvlBqQ"]
}